import React from 'react';
import { DownArrowBlack } from 'src/assets/images';

interface Props {
  children: React.ReactNode;
  title: string;
  defaultOpen?: boolean;
  className?: string;
  titleStyle?: string;
  rightIcons?: React.ReactNode;
  onClick?: () => void;
}

export function Accordion(props: Props) {
  const { defaultOpen = true } = props;

  const detailsRef = React.useRef<HTMLDetailsElement>(null);
  const [isOpen, setIsOpen] = React.useState(defaultOpen);

  const handleClick = () => {
    if (props.onClick) {
      props.onClick();
    }
    setIsOpen((prev) => !prev);
  };

  const arrowClick = (e) => {
    e.preventDefault();
    detailsRef.current?.click();
    setIsOpen((prev) => !prev);
  };

  return (
    <details
      open={isOpen}
      ref={detailsRef}
      onClick={handleClick}
      className={`group ${props.className}`}
    >
      <summary className="flex flex-wrap items-center mb-5 list-none pointer-events-none">
        <h1 className="flex flex-1 text-lg md:text-3xl">{props.title}</h1>
        <div className="flex items-center justify-center gap-4">
          {props.rightIcons}
          <img
            className={`w-5 h-5 cursor-pointer pointer-events-auto transition-transform origin-center ${
              isOpen ? 'rotate-180' : ''
            }`}
            onClick={arrowClick}
            src={DownArrowBlack}
            alt="arrow"
          />
        </div>
      </summary>
      <div onClick={(e) => e.stopPropagation()}>{isOpen && props.children}</div>
    </details>
  );
}
